
import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";
import { UserRole } from "@/types/strategy-types";

interface UserTableFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  roleFilter: string | null;
  onRoleFilterChange: (value: string | null) => void;
}

const UserTableFilters = ({ 
  searchTerm, 
  onSearchChange, 
  roleFilter, 
  onRoleFilterChange 
}: UserTableFiltersProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      <div className="relative flex-1">
        <Input
          placeholder="Search by name or email..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-8"
        />
        <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
      </div>
      <Select
        value={roleFilter || "all"}
        onValueChange={(value) => onRoleFilterChange(value === "all" ? null : value)}
      >
        <SelectTrigger className="w-full sm:w-[200px]">
          <SelectValue placeholder="Filter by role" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Roles</SelectItem>
          <SelectItem value={UserRole.Admin}>Admin</SelectItem>
          <SelectItem value={UserRole.User}>User</SelectItem>
          <SelectItem value={UserRole.StrategyProvider}>Strategy Provider</SelectItem>
          <SelectItem value={UserRole.Editor}>Editor</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default UserTableFilters;
